import React from 'react';
import { Modal, Upload, Button, Form, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';

class ImportMdoal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      dataSource: [],
    };
  }
  handleOk = () => {
    if (!this.state.dataSource.length) {
      message.error('请先上传文件');
      return;
    }
    this.props.addSymbol(this.state.dataSource);
    this.props.onHide();
  }
  parseExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(firstSheet);
      console.log('解析后的Excel数据:', jsonData);
      if (!jsonData || !jsonData.length) {
        message.error('解析后的Excel数据为空');
        return;
      }
      const dataSource = jsonData.map(item => {
        return {
          symbol: item.股票,
          name: item.股票中文名,
          last: Number.parseInt(item.最新价) || 0,
          preClose: Number.parseInt(item.昨收价) || 0,
          open: Number.parseInt(item.开盘价) || 0,
          high: Number.parseInt(item.最高价) || 0,
          low: Number.parseInt(item.最低价) || 0,
        };
      });
      console.log('处理后的数据:', dataSource);
      this.setState({ dataSource });
    };
    reader.readAsArrayBuffer(file);
  }
  render() {
    return (
      <div>
        <Modal
          onCancel={this.props.onHide}
          title="导入mock数据"
          open={true}
          visible={true}
          onOk={this.handleOk}
          width={700}
          okText="导入"
          cancelText="取消"
        >
          <div style={{ marginLeft: '50px' }}>
            <Form.Item style={{ width: '300px' }} label="文件上传" rules={[{ required: true, message: '请上传文件' }]}>
              <Upload
                accept='.csv, .xlsx, .xls'
                beforeUpload={async file => {
                  this.parseExcelFile(file);
                  return false; // 阻止自动上传
                }}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>上传文件</Button>
              </Upload>
            </Form.Item>
            <div>
              说明:
              1、支持xls/xlsx文件。<br />
              2、第一行为表头，顺序确保为:股票、股票中文名、最新价、昨收价、开盘价、最高价、最低价。<br />
              3、最新价为0时，取最近日线的收盘价，其余价格为0时不mock。<br />
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

export default ImportMdoal;